if (!customElements.get('cart-countdown-timer')) {
  class CartCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.targetTime = null;
    }
    
    connectedCallback() {
      this.timerElement = this.querySelector('.countdown-timer');
      this.countdownContent = this.querySelector('.countdown-content');
      this.expiryContent = this.querySelector('.expiry-content');
      this.afterExpiry = this.dataset.afterExpiry;

      this.cartDrawer = document.querySelector('cart-drawer[data-cart-drawer-cart]');
      
      if (!this.cartDrawer) {
        console.warn('cart-drawer element not found');
      }
      
      this.updateVisibility();
      this.observeCartChanges();
      
      if (this.shouldShowCountdown()) {
        this.calculateTargetTime();
        this.startCountdown();
      }
      else {
        this.resetTimer();
      }
    }
    
    observeCartChanges() {
      if (this.cartDrawer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-drawer-cart') {
              this.updateVisibility();
            }
          });
        });
        
        observer.observe(this.cartDrawer, {
          attributes: true,
          attributeFilter: ['data-cart-drawer-cart']
        });
      } else {
        console.warn('cart-drawer element not found');
      }
    }
    
    updateVisibility() {
      if (this.shouldShowCountdown()) {
        this.style.display = 'block';
        
        if (!this.interval && this.targetTime) {
          this.startCountdown();
        } else if (!this.targetTime) {
          this.calculateTargetTime();
          this.startCountdown();
        }
      } else {
        this.style.display = 'none';
        this.resetTimer();
      }
    }
    
    disconnectedCallback() {
      if (this.interval) {
        this.resetTimer();
      }
    }

    resetTimer() {
        clearInterval(this.interval);
        
        this.targetTime = null;

        sessionStorage.removeItem('cart_countdown_timer');
    }
    
    shouldShowCountdown() {
      const enableAll = this.dataset.enableAll === 'true';
      
      if (enableAll) {
        return true;
      }
      
      try {
        const cartDataRaw = this.cartDrawer.getAttribute('data-cart-drawer-cart');
        
        if (!cartDataRaw) {
          return false;
        }
        
        const cartData = JSON.parse(cartDataRaw);
        const cartItems = cartData.items || [];
        
        if (cartItems.length === 0) {
          return false;
        }
        
        const listKey = 'countdown_enabled_products';
        let countdownProducts = [];
        
        try {
          const stored = localStorage.getItem(listKey);
          countdownProducts = stored ? JSON.parse(stored) : [];
        } catch (e) {
          console.error('Error reading countdown products list:', e);
          return false;
        }
        
        const hasCountdownProduct = cartItems.some(item => {
          const productId = item.product_id;
          return countdownProducts.includes(productId);
        });
        
        return hasCountdownProduct;
      } catch (e) {
        console.error('Error checking cart items for countdown:', e);
        return false;
      }
    }
    
    calculateTargetTime() {
      const storageKey = 'cart_countdown_timer';
      const storedEndTime = sessionStorage.getItem(storageKey);
      
      if (storedEndTime) {
        this.targetTime = parseInt(storedEndTime);
        
        if (Date.now() >= this.targetTime) {
          this.targetTime = parseInt(storedEndTime);
        }
      } else {
        this.startNewTimer(storageKey);
      }
    }
    
    startNewTimer(storageKey) {
      const hoursRaw = this.dataset.fixedHours;
      const minutesRaw = this.dataset.fixedMinutes;
      const secondsRaw = this.dataset.fixedSeconds;
      
      const hours = hoursRaw !== undefined && hoursRaw !== null && hoursRaw !== '' 
        ? parseInt(hoursRaw) 
        : 0;
      const minutes = minutesRaw !== undefined && minutesRaw !== null && minutesRaw !== '' 
        ? parseInt(minutesRaw) 
        : 15;
      const seconds = secondsRaw !== undefined && secondsRaw !== null && secondsRaw !== '' 
        ? parseInt(secondsRaw) 
        : 0;
      
      const durationMs = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000);
      this.targetTime = Date.now() + durationMs;
      
      sessionStorage.setItem(storageKey, this.targetTime.toString());
    }
    
    updateCountdown() {
      const now = Date.now();
      const diff = this.targetTime - now;
      
      if (diff <= 0) {
        this.countdownContent.classList.add('hidden');
        
        if (this.afterExpiry === 'hide') {
          this.style.display = 'none';
        } else {
          this.expiryContent.classList.remove('hidden');
        }
        
        if (this.interval) {
          clearInterval(this.interval);
        }
        return;
      }
      
      this.countdownContent.classList.remove('hidden');
      this.expiryContent.classList.add('hidden');
      
      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      let displayText = '';
      
      if (hours > 0) {
        displayText = String(hours).padStart(2, '0') + ':' + 
                     String(minutes).padStart(2, '0') + ':' + 
                     String(seconds).padStart(2, '0');
      } else {
        displayText = String(minutes).padStart(2, '0') + ':' + 
                     String(seconds).padStart(2, '0');
      }
      
      this.timerElement.textContent = displayText;
    }
    
    startCountdown() {
      if (!this.targetTime) return;
      
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }
  }
  
  customElements.define('cart-countdown-timer', CartCountdownTimer);
}
